import React from 'react';
import { Badge } from 'react-bootstrap';
import { FaMapMarkerAlt, FaStar, FaDollarSign } from 'react-icons/fa';
import {
    FaPizzaSlice,
    FaCoffee,
    FaUtensils,
    FaDumbbell,
    FaTree,
    FaPills,
    FaHospital,
    FaGasPump,
    FaHotel,
    FaUniversity,
    FaStore,
    FaShoppingBag,
} from 'react-icons/fa';

/**
 * Compact place card for the Places side panel.
 * Follows the PropertyCard styling pattern.
 */
function PlaceCard({ item, selected, onClick }) {
    const cats = item.categoryNames || item.types || [];
    const distanceStr = item.distance != null ? `${item.distance} m` : '';
    const rating = item.rating != null ? Number(item.rating).toFixed(1) : null;
    const priceLevel = item.price || item.priceLevel;

    // Category icon
    const categoryIcon = (() => {
        const catStr = cats.join(' ').toLowerCase();
        if (/pizza/.test(catStr)) return <FaPizzaSlice />;
        if (/coffee|cafe/.test(catStr)) return <FaCoffee />;
        if (/restaurant|food|dining|lunch|dinner|breakfast/.test(catStr)) return <FaUtensils />;
        if (/gym|fitness/.test(catStr)) return <FaDumbbell />;
        if (/park/.test(catStr)) return <FaTree />;
        if (/pharmacy|drug/.test(catStr)) return <FaPills />;
        if (/hospital|clinic|medical/.test(catStr)) return <FaHospital />;
        if (/gas|fuel/.test(catStr)) return <FaGasPump />;
        if (/hotel|motel|lodging/.test(catStr)) return <FaHotel />;
        if (/library|campus|university|school/.test(catStr)) return <FaUniversity />;
        if (/shop|store|grocery|market|mall/.test(catStr)) return <FaShoppingBag />;
        return <FaStore />;
    })();

    // Price badges
    const priceBadges = priceLevel
        ? Array.from({ length: Math.min(Number(priceLevel), 4) }, (_, i) => (
              <FaDollarSign key={i} style={{ color: '#1a73e8', fontSize: 10 }} />
          ))
        : null;

    return (
        <div
            onClick={onClick}
            style={{
                cursor: 'pointer',
                padding: '12px 14px',
                borderBottom: '1px solid #eee',
                background: selected ? '#e8f4fd' : 'transparent',
                transition: 'background 0.15s',
            }}
            onMouseEnter={(e) => {
                if (!selected) e.currentTarget.style.background = '#f7f9fc';
            }}
            onMouseLeave={(e) => {
                if (!selected) e.currentTarget.style.background = 'transparent';
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, color: '#222' }}>
                        <span style={{ color: '#d64545', fontSize: 12, marginRight: 4 }}>{categoryIcon}</span>
                        {item.name || '(unnamed place)'}
                    </div>
                    <div style={{ color: '#777', fontSize: 12, marginTop: 2 }}>
                        <FaMapMarkerAlt style={{ color: '#d64545', fontSize: 10, marginRight: 3 }} />
                        {item.formattedAddress || '-'}
                    </div>
                </div>
                <div style={{ textAlign: 'right', flexShrink: 0, marginLeft: 8 }}>
                    {rating && (
                        <div
                            style={{
                                fontWeight: 700,
                                fontSize: 14,
                                color: '#e8770e',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2,
                                justifyContent: 'flex-end',
                            }}
                        >
                            <FaStar style={{ color: '#f5a623', fontSize: 11 }} /> {rating}
                        </div>
                    )}
                    {priceBadges && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>{priceBadges}</div>
                    )}
                </div>
            </div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6, alignItems: 'center' }}>
                {item._isLocalChannel && (
                    <Badge variant="success" style={{ fontSize: 11 }}>
                        Optonome Channel
                    </Badge>
                )}
                {cats.slice(0, 3).map((cat, i) => (
                    <Badge key={i} variant="light" style={{ fontSize: 11, color: '#555' }}>
                        {cat}
                    </Badge>
                ))}
                {distanceStr && <span style={{ fontSize: 11, color: '#999' }}>{distanceStr}</span>}
                {item.source && (
                    <span style={{ fontSize: 11, color: '#aaa', textTransform: 'capitalize' }}>{item.source}</span>
                )}
            </div>
        </div>
    );
}

export default PlaceCard;
